import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { CloneAndConversionService as BaseCloneAndConversionService } from "../../../shared/services/cloneAndConversionService";
import { Machine } from "../../models/machine";
import { MachineConfiguration } from "../../models/machineConfiguration";
import { IQService } from "angular";
import {
  GratonUtilsService,
  vsServiceName as GratonUtilsServiceName,
} from "../../utils";

export const vsServiceName = "cloneAndConversionService";

export class CloneAndConversionService extends BaseCloneAndConversionService<
  Machine,
  MachineConfiguration
> {
  static $inject = [ServerUtilityName, "$q", GratonUtilsServiceName];
  constructor(
    serverUtility: ServerUtility,
    $q: IQService,
    private readonly gratonUtilsService: GratonUtilsService
  ) {
    super(serverUtility, $q);
  }

  protected override prepareConversionConfiguration(
    conversionConfiguration: MachineConfiguration,
    currentConfiguration: MachineConfiguration
  ): MachineConfiguration {
    const result = super.prepareConversionConfiguration(
      conversionConfiguration,
      currentConfiguration
    );

    result.Eproms = this.gratonUtilsService.normalizeEproms(
      result.Eproms ?? []
    );

    result.MachineSectionId = currentConfiguration.MachineSectionId;
    result.MachineSection = currentConfiguration.MachineSection;

    return result;
  }
}
